module.exports = __webpack_public_path__ + "img/DIMA_BLBERRY_ARTWORK.jpg";